// easyui-datagrid.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, ElementRef, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-datagrid',
  template: `
    <div style="height: 100%">
      <div #host>
        <ng-content></ng-content>
      </div>
    </div>
  `
})
export class EasyuiDatagridComponent implements AfterViewInit {
  protected host: any
  protected focuspanel: any
  private invio: Function = null
  private destra: Function = null
  private sinistra: Function = null
  // riferimenti alla view
  @ViewChild('host') hostElement: ElementRef
  // bind in ingresso
  @Input('options') options: any = {}
  // bind in uscita
  // @Output() onOverTop = new EventEmitter<void>()
  // @Output() onBelowBottom = new EventEmitter<void>()
  // @Output() onCheck = new EventEmitter<number>()
  // @Output() onUncheck = new EventEmitter<number>()
  // @Output() onKeydown = new EventEmitter<any>()
  // @Output() onKeypress = new EventEmitter<any>()
  // @Output() onSpace = new EventEmitter<any>()
  // @Output() onBlur = new EventEmitter<EasyuiDatagridComponent>()

  // inizializzazione component

  constructor() { }

  ngAfterViewInit() {
    this.configura(this.options)
  }

  // metodi pubblici

  public loadDati(dati) {
    this.host.datagrid('loadData', dati)
  }

  public updateOptions(options) {
    this.options = options;
    this.configura(this.options);
  }

  public setFocus() {
    setTimeout(() => {
      this.host.datagrid('getPanel').panel('panel').focus()
    }, 1)
  }

  public getCurrentCell() {
    return this.host.datagrid('cell')
  }

  public getCurrentEditor(): any {
    let cell = this.getCurrentCell()
    let ed = null
    if (cell) {
      ed = this.getEditor(cell.index, cell.field)
    }
    return ed
  }

  public getEditor(index: number, field: string): any {
    return this.host.datagrid('input', { index: index, field: field })
    // return this.host.datagrid('getColumnOption', field).editor
  }

  public isEditing(index: number) {
    return this.host.datagrid('isEditing',index)
  }

  public getPanel(): any {
    return this.host.datagrid('getPanel').panel('panel')
  }

  public getHeader(): any {
    let panel = this.getPanel()
    let header = panel.find('div.datagrid-header')
    return header
  }

  public editCell(index: number, field: string) {
    this.host.datagrid('editCell', { index: index, field: field })
  }

  public getRows() {
    return this.host.datagrid('getRows')
  }

  public getRowsNum() {
    let rows = this.getRows()
    if (rows) return rows.length
    return 0
  }

  public getData() {
    return this.host.datagrid('getData')
  }

  public getRow(rowNum: number) {
    let rows = this.getRows()
    if (rows && (rows.length > 0) && (rowNum < rows.length)) return rows[rowNum]
    return null
  }

  public getRowIndex(row: any) {
    return this.host.datagrid('getRowIndex', row)
  }

  public getSelectedRow() {
    return this.host.datagrid('getSelected')
  }

  public getSelectedRowIndex() {
    let row = this.getSelectedRow()
    return row ? this.getRowIndex(row) : -1
  }

  public getSelectedCells() {
    return this.host.datagrid('getSelectedCells')
  }

  public selectRow(rowNum: number) {
    let num = this.getRowsNum()
    if (num > 0) this.host.datagrid('selectRow', rowNum)
  }

  public unselectRow(rowNum: number) {
    let num = this.getRowsNum()
    if (num > 0) this.host.datagrid('unselectRow', rowNum)
  }

  public checkRow(rowNum: number) {
    this.host.datagrid('checkRow', rowNum)
  }

  public uncheckRow(rowNum: number) {
    this.host.datagrid('uncheckRow', rowNum)
  }

  public uncheckAll() {
    this.host.datagrid('clearChecked')
  }

  public getCheckedRows(): Array<any> {
    let rr: Array<any> = [];
    let rows = this.getRows()
    this.host.datagrid('getPanel').find('div.datagrid-cell-check input:checked').each(function () {
      let index = $(this).parents('tr.datagrid-row:first').attr('datagrid-row-index');
      rr.push(rows[index]);
    });
    return rr;
  }

  public getCheckedIdxs(): Array<number> {
    let rr: Array<number> = [];
    let rows = this.getRows()
    this.host.datagrid('getPanel').find('div.datagrid-cell-check input:checked').each(function () {
      let index = $(this).parents('tr.datagrid-row:first').attr('datagrid-row-index');
      rr.push(index);
    });
    return rr;
  }

  public removeCheckedRows() {
    let rows = this.getCheckedRows()
    for (let row of rows) {
      let idx = this.getRowIndex(row)
      this.deleteRow(idx)
    }
    this.selectRow(0)
  }

  public unselect() {
    let selectedRow = this.getSelectedRow()
    let index = this.host.datagrid('getRowIndex', selectedRow);
    this.unselectRow(index)
  }

  public unselectAll() {
    this.host.datagrid('unselectAll')
  }

  public appendRow(row: any) {
    this.host.datagrid('appendRow', row)
  }

  public insertRow(rowNum: number, rowData: any) {
    let rowParam = {
      index: rowNum,
      row: rowData
    }
    this.host.datagrid('insertRow', rowParam)
  }

  public updateRow(rowNum: number, rowData: any) {
    let rowParam = {
      index: rowNum,
      row: rowData
    }
    this.host.datagrid('updateRow', rowParam)
  }

  public refreshRow(rowNum: number) {
    this.host.datagrid('refreshRow', rowNum)
  }

  public deleteRow(rowNum: number) {
    this.host.datagrid('deleteRow', rowNum)
  }

  public validateRow(rowNum: number): boolean {
    return this.host.datagrid('validateRow', rowNum)
  }

  public sort(field: string, order: string) {
    let sortParam = {
      sortName: field,
      sortOrder: order
    }
    this.host.datagrid('sort', sortParam)
  }

  public beginEdit(rowNum: number) {
    this.host.datagrid('beginEdit', rowNum)
  }

  public endEdit(rowNum: number) {
    this.host.datagrid('endEdit', rowNum)
  }

  public cancelEdit(rowNum: number) {
    this.host.datagrid('cancelEdit', rowNum)
  }

  public enableCellEditing() {
    this.host.datagrid('enableCellEditing')
  }

  public disableCellEditing() {
    this.host.datagrid('disableCellEditing')
  }

  public enableCellSelecting() {
    this.host.datagrid('enableCellSelecting')
  }

  public disableCellSelecting() {
    this.host.datagrid('disableCellSelecting')
  }

  public resize() {
    this.host.datagrid('resize')
  }

  public fixDetailRowHeight(rowNum: number) {
    this.host.datagrid('fixDetailRowHeight', rowNum)
  }

  public gotoCell(index: number, field: string) {
    this.host.datagrid('gotoCell', { index: index, field: field })
  }

  // funzioni di filtro

  public enableFilter(filter?: any) {
    if (filter) {
      this.host.datagrid('enableFilter', filter)
    }
    else {
      this.host.datagrid('enableFilter')
    }
  }

  public disableFilter()  {
    this.host.datagrid('disableFilter')
  }

  public destroyFilter() {
    this.host.datagrid('destroyFilter')
  }

  public getFilterRule(field: string): any {
    return this.host.datagrid('getFilterRule', field)
  }

  public addFilterRule(filter: any) {
    this.host.datagrid('addFilterRule', filter)
  }

  public removeFilterRule(field: string) {
    this.host.datagrid('removeFilterRule', field)
  }

  public doFilter() {
    this.host.datagrid('doFilter')
  }

  public getFilterComponent(field: string): any {
    return this.host.datagrid('getFilterComponent', field)
  }

  public resizeFilter(field: string) {
    this.host.datagrid('resizeFilter')
  }

  public styleElement( tag: string, css: any) {
    let element = this.host.find(tag)
    element.css(css)
  }

  // metodi privati

  protected configura(options: any) {
    this.host = $(this.hostElement.nativeElement)
    let localoptions = {
      fit: false,
      editorHeight: 24
    }
    const newOptions = Object.assign(localoptions, options)
    this.host.datagrid(newOptions)
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-datagrid.component.ts